import { useIdentityStore } from './store';

export const enabled = (flag: string): boolean => {
	const features = useIdentityStore.getState().features;

	return features?.[flag]?.enabled ?? false;
};
